$(document).ready(function(){

  $('.tabs__header [for="tab1"]').hide();
  $('.tabs__header [for="tab2"]').trigger('click');
  
  $('.colos_nav_btn').click(function(){
      $('.colos_nav_btn').removeClass('active');
      $(this).addClass('active');
      var currentId = $(this).attr('data-id');
      $('.dynamicContent').addClass('hidden');
      $('.dynamicContent[data-id="'+currentId+'"]').removeClass('hidden');
    });

  $('.col_point_exact').click(function(){
    $(this).closest('.col_section_outer').find('.col_point_exact').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.col_section_outer').find('.col_point-point-box').removeClass('active');
    var currentId = $(this).attr('data-id');
    $('.col_point-point-box[data-id="'+currentId+'"]').addClass('active');
  });

  $('.col_point-point-box').click(function(){
    $(this).closest('.col_section_outer').find('.col_point-point-box').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.col_section_outer').find('.col_point_exact').removeClass('active');
    var currentId = $(this).attr('data-id');
    $('.col_point_exact[data-id="'+currentId+'"]').addClass('active');
  });

  $('.col-power-fullbox').click(function(){
    $('.col-power-fullbox').removeClass('active');
    $(this).addClass('active');
  });

  $('.col_rebuild-box').click(function(){
    $('.col_rebuild-box').removeClass('active');
    $(this).addClass('active');
    var dataId = $(this).attr('data-id');
    $('.col-rebuild_navbtn').removeClass('active');
   $('.col-rebuild_navbtn[data-id="'+dataId+'"]').addClass('active');
  });


  $('.col_article-nav-next').click(function() {
    $('.col_article-nav-prev').removeClass('disabled');
  
    var $grid = $('.col_articles-grid-outer');
    var scrollLeft = $grid.scrollLeft();
    var maxScrollLeft = $grid[0].scrollWidth - $grid.outerWidth();
  
    // Scroll 700px to the right
    var toSlide = $('.col_article-box').outerWidth() + 12;
    $grid.animate({ scrollLeft: scrollLeft + toSlide }, 300, function() {
      var newScrollLeft = $grid.scrollLeft();
  
      // Add a small buffer (tolerance) to handle rounding issues
      if (newScrollLeft + 5 >= maxScrollLeft) {
        $('.col_article-nav-next').addClass('disabled');
      }
    });
  });


  $('.col_article-nav-prev').click(function() {
    $('.col_article-nav-next').removeClass('disabled');
  
    var $grid = $('.col_articles-grid-outer');
    var scrollLeft = $grid.scrollLeft();
  
    // Scroll 700px to the left
    var toSlide = $('.col_article-box').outerWidth() + 12;
    $grid.animate({ scrollLeft: scrollLeft - toSlide }, 300, function() {
      var newScrollLeft = $grid.scrollLeft();
  
      // If at the beginning (with small buffer)
      if (newScrollLeft <= 5) {
        $('.col_article-nav-prev').addClass('disabled');
      }
    });
  });


  $('.mp_selection-box').click(function(){
    $('.mp_selection-box').removeClass('active');
    $(this).addClass('active');
  });

});